<template>
  <!-- 获得荣誉 -->
  <ul class="gift-list">
    <li class="gift-item">
      <img src="../images/icon-tower.png" class="gift-item-img"/>
      共计
      <span class="gift-num">{{ lessonNum }}</span>
      <span class="gift-label">完成关卡</span>
    </li>
    <li class="gift-item">
      <img src="../images/icon-gift.png" class="gift-item-img"/>
      共计
      <span class="gift-num">{{ giftNum }}</span>
      <span class="gift-label">获得礼物</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "UserInfo",
  props: {
    lessonNum: {
      type: Number,
      default: 0,
    },
    giftNum: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style scoped>
.gift-list {
  display: flex;
  justify-content: space-around;
  gap: 20px;
  list-style: none;
  margin: 0;
  padding: 0;
}
.gift-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 180px;
  padding: 20px 0;
  border-radius: 24px;
  box-shadow: 0px 1px 3px 0px rgba(153,37,6,0.41), 0px -3px 4px 0px #ecc596 inset;
  background: url('../images/gift-item-bg.png') center bottom/100% no-repeat #fff3d3;
  font-size: 20px;
  color: #818181;
}
.gift-item-img {
  width: 54px;
  height: 58px;
  margin-bottom: 12px;
}
.gift-num {
  margin-top: 8px;
  font-size: 34px;
  font-weight: 700;
  color: #8bb91c;
}
.gift-label {
  font-size: 24px;
  font-weight: bold;
  color: #6f6c68;
}

</style>